export default __webpack_public_path__ + "static/Epitomizing-Strategic-da9b26a1e9b2a8482ca513e2181f1952.webp";